.coverage-cell{display:flex;align-items:center;height:100%;gap:8px}.status-indicator{font-size:.7em;flex-shrink:0}.coverage-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:calc(100% - 16px)}
/*# sourceMappingURL=coverage-table-network-cell.component-V3W2CNSM.css.map */
